export interface Category {
  name: string;
  slug: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Three%20pairs%20of%20designer%20sneakers%20arranged%20diagonally%20on%20warm%20terracotta%20concrete%20surface%2C%20morning%20sunlight%20casting%20soft%20shadows%2C%20editorial%20fashion%20photography%2C%20textured%20background%2C%20minimal%20composition%20with%20negative%20space&width=800&height=600&seq=shoes-card-v3&orientation=landscape",
  },
  {
    name: "Hoodies/Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Oversized%20cream%20knit%20sweater%20draped%20artfully%20over%20vintage%20wooden%20chair%2C%20afternoon%20light%20streaming%20through%20linen%20curtains%2C%20cozy%20Scandinavian%20interior%2C%20warm%20neutral%20palette%2C%20soft%20texture%20focus%2C%20lifestyle%20photography&width=800&height=600&seq=hoodies-card-v3&orientation=landscape",
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20white%20cotton%20t-shirt%20folded%20neatly%20on%20light%20oak%20wooden%20table%2C%20small%20potted%20succulent%20beside%20it%2C%20bright%20natural%20daylight%2C%20clean%20minimal%20aesthetic%2C%20lifestyle%20flat%20lay%2C%20fresh%20modern%20composition&width=800&height=600&seq=tshirts-card-v3&orientation=landscape",
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20hanging%20on%20minimalist%20brass%20wall%20hook%2C%20warm%20terracotta%20accent%20wall%20behind%2C%20soft%20directional%20lighting%2C%20contemporary%20fashion%20editorial%2C%20textured%20fabric%20detail%2C%20elegant%20moody%20atmosphere&width=800&height=600&seq=jackets-card-v3&orientation=landscape",
  },
  {
    name: "Pants/Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20paired%20with%20casual%20shorts%20displayed%20on%20minimalist%20clothing%20rack%2C%20soft%20studio%20lighting%2C%20warm%20sand%20colored%20background%2C%20contemporary%20fashion%20flat%20lay%2C%20natural%20textures%2C%20relaxed%20summer%20vibe&width=800&height=600&seq=pants-card-v3&orientation=landscape",
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20caps%20and%20beanies%20arranged%20on%20rustic%20wooden%20shelf%2C%20warm%20candlelight%20glow%2C%20cozy%20autumn%20atmosphere%2C%20textured%20wool%20and%20cotton%20fabrics%2C%20editorial%20accessories%20photography%2C%20intimate%20composition&width=800&height=600&seq=headwear-card-v3&orientation=landscape",
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20streetwear%20outfit%20set%20laid%20out%20on%20concrete%20floor%2C%20top-down%20view%2C%20industrial%20loft%20setting%20with%20exposed%20brick%2C%20soft%20window%20light%2C%20editorial%20fashion%20flat%20lay%2C%20urban%20aesthetic%2C%20harmonious%20color%20palette&width=800&height=600&seq=sets-card-v3&orientation=landscape",
  },
  {
    name: "Underwear/Underpants",
    slug: "underwear-underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20underwear%20neatly%20folded%20on%20white%20linen%20fabric%2C%20eucalyptus%20branch%20as%20decoration%2C%20gentle%20morning%20light%2C%20spa-like%20clean%20aesthetic%2C%20minimalist%20wellness%20photography%2C%20pure%20serene%20composition&width=800&height=600&seq=underwear-card-v3&orientation=landscape",
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20displayed%20on%20minimalist%20mannequin%20torso%2C%20studio%20lighting%20with%20dramatic%20shadows%2C%20dark%20charcoal%20background%2C%20athletic%20fabric%20texture%20visible%2C%20modern%20sportswear%20photography%2C%20powerful%20dynamic%20composition&width=800&height=600&seq=jersey-card-v3&orientation=landscape",
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20watches%20and%20minimalist%20jewelry%20scattered%20on%20polished%20travertine%20stone%20surface%2C%20golden%20hour%20sunlight%2C%20luxury%20editorial%20photography%2C%20warm%20honey%20tones%2C%20sophisticated%20curated%20layout%2C%20refined%20composition&width=800&height=600&seq=accessories-card-v3&orientation=landscape",
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20leather%20tote%20bag%20placed%20on%20mid-century%20modern%20armchair%2C%20cozy%20living%20room%20corner%2C%20warm%20afternoon%20light%2C%20rich%20cognac%20leather%20texture%2C%20lifestyle%20interior%20photography%2C%20inviting%20sophisticated%20atmosphere&width=800&height=600&seq=bags-card-v3&orientation=landscape",
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20elegantly%20coiled%20on%20dark%20walnut%20wood%20surface%2C%20brass%20buckle%20detail%20catching%20light%2C%20rich%20textured%20leather%2C%20warm%20dramatic%20studio%20lighting%2C%20artisan%20product%20photography%2C%20masculine%20refined%20aesthetic&width=800&height=600&seq=belts-card-v3&orientation=landscape",
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Luxury%20fragrance%20bottles%20arranged%20on%20black%20marble%20surface%2C%20delicate%20white%20orchid%20beside%20them%2C%20soft%20dramatic%20spotlighting%2C%20premium%20product%20photography%2C%20sophisticated%20dark%20elegant%20composition%2C%20crystal%20glass%20reflections&width=800&height=600&seq=perfumes-card-v3&orientation=landscape",
  },
  {
    name: "Other Stuff",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Eclectic%20curated%20lifestyle%20items%20including%20notebook%20candle%20and%20ceramic%20mug%20on%20reclaimed%20wood%20table%2C%20soft%20evening%20light%2C%20warm%20boho%20aesthetic%2C%20editorial%20still%20life%2C%20cozy%20thoughtful%20composition%2C%20organic%20textures&width=800&height=600&seq=other-card-v3&orientation=landscape",
  },
];

export const categoryColumns = [
  categories.slice(0, 5),
  categories.slice(5, 10),
  categories.slice(10, 14),
];